export default __webpack_public_path__ + "static/media/academic-majors.eaf3038f.svg";